
import { z } from "zod";

export const EscrowStatusValues = ["CANCELLED", "DISBURSED", "DISPUTED", "FUNDED", "FUNDS_FAILED", "PARTIALLY_DISBURSED", "PARTIALLY_FUNDED", "PARTIALLY_PENDING", "PENDING", "PROBLEM", "SENT"] as const;
export const EscrowStatusSchema = z.enum(EscrowStatusValues);
export const EscrowStatus = EscrowStatusSchema.enum;
export type EscrowStatus = (typeof EscrowStatusValues)[number];
export const EscrowStatusDisplayNames = { "CANCELLED": "Cancelled",
"DISBURSED": "Disbursed",
"DISPUTED": "Disputed",
"FUNDED": "Funded",
"FUNDS_FAILED": "Funds failed",
"PARTIALLY_DISBURSED": "Partially disbursed",
"PARTIALLY_FUNDED": "Partially funded",
"PARTIALLY_PENDING": "Partially funded (pending)",
"PENDING": "Funded (pending)",
"PROBLEM": "Problem",
"SENT": "Sent", } satisfies Record<EscrowStatus, string>;
